<template>
  <div class="contain">
    <div class="landing_bg"></div>
    <div class="landing_bg_left"></div>
    <div class="landing_contain flex">
      <div class="landing_content">
        <div class="logo">
          <img src="../assets/images/white_logo.png" />
        </div>
        <div class="tab flex">
          <div
            v-for="(item, index) in tab"
            :key="index"
            :class="tabClick == index ? 'tab_check' : ''"
            @click="tabClickEvent(item, index)"
          >
            {{ item.name }}
          </div>
          <span
            class="tab_bar_check"
            :style="`width:${100 / tab.length}%; left:${
              tabClick == 0 ? 0 : tabClick * (100 / tab.length)
            }%`"
          ></span>
          <!-- 117 - 100 / (tabClick * 1.5) -->
        </div>
        <div class="tab_conten">
          <MyTransition :myName="'left'">
            <Login :type="tabClick" :key="tabClick" v-if="type=='login'"></Login>
            <div v-for="(paper,index) in paper_list" :key="index" @click="link(paper.file_path)">
              <button class="btn_border">
                {{paper.file_name}}
              </button>
            </div>
          </MyTransition>
        </div>
      </div>
      <div class="landing_icon">
        <img class="bg1" src="../assets/images/bg1.png" />
        <img class="bg2" src="../assets/images/bg2.png" />
        <img class="logo" src="../assets/images/logo.png" />
        <div class="landing_icon_inside">
          <div class="circle"></div>
          <div class="triangle"></div>
          <div class="rect"></div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<style lang="scss">
.landing_bg {
  background: linear-gradient(to bottom right, var(--mainColor), #4c2adf);
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
  position: fixed;
  z-index: -1;
}
.landing_bg_left {
  background: #4d15dc;
  width: 45%;
  height: 100vh;
  top: 0px;
  left: 0px;
  position: fixed;
}
.landing_contain {
  width: 100%;
  align-items: center;
  position: relative;
  justify-content: space-around;
  .landing_icon {
    flex: 5;
    position: relative;
    top: 0px;
    height: calc(100vh - 100px);
    img {
      position: absolute;
      &.bg1 {
        top: 0px;
        right: 0;
      }
      &.bg2 {
        right: -50px;
        bottom: 0px;
      }
      &.logo {
        top: 20%;
        right: 10%;
      }
    }
    .landing_icon_inside {
      position: absolute;
      top: 10%;
      right: 15%;
      width: 280px;
      div {
        position: absolute;
      }
      .circle {
        background: var(--subColor);
        width: 110px;
        height: 110px;
        border-radius: 50%;
        top: 250px;
        z-index: 2;
        animation: circle 1s 0.5s backwards;
      }
      @keyframes circle {
        0% {
          opacity: 0;
          top: 300px;
        }
        100% {
          opacity: 1;
          top: 250px;
        }
      }
      .triangle {
        z-index: 1;
        top: 100px;
        left: -120px;
        width: 245px;
        height: 213px;
        background: #fff21f;
        opacity: 0.9;
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        animation: triangle 1.5s 0.1s backwards;
      }
      @keyframes triangle {
        0% {
          left: -300px;
          opacity: 0;
          transform: rotate(250deg);
        }
        100% {
          opacity: 0.9;
          top: 100px;
          left: -120px;
          transform: rotate(0deg);
        }
      }
      .rect {
        top: 180px;
        left: 50px;
        z-index: 3;
        width: 140px;
        height: 140px;
        background: #2ed0ff;
        opacity: 0.8;
        animation: rect 1s 0.7s backwards;
      }
      @keyframes rect {
        0% {
          opacity: 0;
          left: 100px;
        }
        100% {
          opacity: 0.8;
          top: 180px;
          left: 50px;
        }
      }
    }
  }
  .landing_content {
    flex: 3;
    position: relative;
    z-index: 4;
    padding: 30px;
    .tab {
      margin: 20px 0;
      position: relative;
      color: var(--mainColor2);
      justify-content: space-around;
      border-bottom: 1px solid var(--mainColor2);
      padding: 15px 10px;
      > div {
        cursor: pointer;
        margin: 0 10px;
        text-align: center;
        &.tab_check {
          color: #fff;
          font-weight: bold;
        }
        &:hover {
          color: #fff;
          font-weight: bold;
        }
      }
      .tab_bar_check {
        position: absolute;
        background: var(--lightColor);
        height: 3px;
        top: 45px;
        left: 0px;
      }
    }
    .tab_conten {
      padding: 10px 30px;
    }
  }
}
</style>

<script>
// @ is an alias to /src
import Login from "@/components/LoginContent.vue";
import List from "@/components/contractor/InstructionList"
import mixins from "@/components/mixins.js";
export default {
  name: "home",
  mixins: [mixins],
  data() {
    return {
      tab: [
        { name: "承攬商", type: "login" },
        { name: "錼創管理區", type: "login" },
        { name: "說明文件", type: "paper" },
      ],
      tabClick: 0,
      type: "login",
      paper_list:[],
    };
  },
  components: {
    Login,
    List,
  },
  methods: {
    tabClickEvent(item, index) {
      this.tabClick = index;
      this.type = item.type;
    },
    getPaper() {
      this.$http.api.file.guideDow().then(res => {
        this.paper_list = res.data;
      });
    },
  },
  created() {
    this.getPaper();
  },
  watch: {
    $route(to, from) {
      // if (to.path == "/contractorlogin") {
      //  //如果跳轉，就用動畫？ 
      //   console.log('跳轉頁面')
      // }
    },
  },
};
</script>
